import { spawn, call, put, takeLatest } from 'redux-saga/effects';
import { createAction } from '@reduxjs/toolkit';
import { sesionActions } from '../../../application/actions/sesion';

import api from '../../api/index';

const apiRequest = api(process.env.REACT_APP_HOST);


// SESION
export function* validarSesion(e) {
    console.log(e.payload)
    yield put(sesionActions.conexionSesion({connection:true}));
    try {
        const  params  = e.payload;
        const url = `session/login`
        const response = yield call(
            apiRequest.post,
            url,
            params,null
        );

        // Extraigo todos los datos
        const { data } = response;
        const { token, user } = data;
        yield put(sesionActions.craerSesion({token, user}));
    } catch (err) {
        yield put(sesionActions.errorSesion({error:true, message:err.message}));
    } finally {
        yield put(sesionActions.conexionSesion({connection:false}));
    }
}

// RECOVERY

export function* recoverPassword(e) {
    yield put(sesionActions.recoverPassword({ connection: true }));
    yield put(sesionActions.conexionSesion({ connection: true }));
    try {
      const params = { email: e.payload };
      const url = 'session/recovery';
      const response = yield call(
        apiRequest.post,
        url,
        params,
      );
  
      // Extraigo todos los datos
      const { data, message } = response;
      if (data) {
        yield put(sesionActions.recoverPassword({ result: true, message, connection: false }));
      } else {
        yield put(sesionActions.recoverPassword({ error: true, message, connection: false }));
      }
    } catch (err) {
      yield put(sesionActions.recoverPassword({
        error: true,
        message: err.message,
        connection: false,
      }));
    } finally {
      yield put(sesionActions.conexionSesion({ connection: false }));
    }
  }


//CHANGE
export function* changePassword(e) {
    yield put(sesionActions.changePassword({
      connection: true, result: false, error: false, message: '',
    }));
    yield put(sesionActions.conexionSesion({ connection: true }));
    try {
      const params = e.payload;
      const { token, password } = params
      const optionalsHeaders = {authorization: `Bearer ${token}`}
      const url = 'session/changepassword';
      const response = yield call(
        apiRequest.post,
        url,
        {password},
        optionalsHeaders
      );
  
      // Extraigo todos los datos
      const { data, message } = response;
  
      if (data) {
        yield put(sesionActions.changePassword({ result: true, message, connection: false }));
      } else {
        const { error } = response;
        yield put(sesionActions.changePassword({ error: true, message:error, connection: false }));
      }
    } catch (err) {
      yield put(sesionActions.changePassword({
        error: true,
        message: err.message,
        connection: false,
      }));
    } finally {
      yield put(sesionActions.conexionSesion({ connection: false }));
    }
  }




export function* watchFetchSesion() {
    yield takeLatest(SesionActionsSaga.activeSesion.type, validarSesion);
    yield takeLatest(SesionActionsSaga.activeChangePasswordd.type, changePassword);
    yield takeLatest(SesionActionsSaga.activeRecoverPassword.type, recoverPassword);


}

export default function* rootSaga() {
    yield spawn(watchFetchSesion);
}


const activeSesion = createAction('sesionSaga/activeSesion');
const activeChangePasswordd = createAction('sesionSaga/activeChangePasswordd');
const activeRecoverPassword = createAction('sesionSaga/activeRecoverPassword');



export const SesionActionsSaga = {
    activeSesion,
    activeChangePasswordd,
    activeRecoverPassword,
};
